import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type PhotoPreviewData = {
  src: string;
  fileName: string;
};

@Injectable({
  providedIn: 'root',
})
export class PhotoPreviewService {
  private readonly photoPreviewContentSubject = new BehaviorSubject<PhotoPreviewData>(null);
  private readonly photoPreviewOpenSubject = new BehaviorSubject<boolean>(false);

  photoPreviewContent$ = this.photoPreviewContentSubject.asObservable();
  photoPreviewOpen$ = this.photoPreviewOpenSubject.asObservable();

  showPhotoPreview(content: PhotoPreviewData) {
    this.photoPreviewContentSubject.next(content);
    this.setPhotoPreviewState(true);
  }

  setPhotoPreviewState(isOpen: boolean) {
    this.photoPreviewOpenSubject.next(isOpen);
  }
}
